import { render, staticRenderFns } from "./PlotList.vue?vue&type=template&id=35d9c93d&scoped=true"
import script from "./PlotList.vue?vue&type=script&lang=ts"
export * from "./PlotList.vue?vue&type=script&lang=ts"
import style0 from "./PlotList.vue?vue&type=style&index=0&id=35d9c93d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d9c93d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d9c93d')) {
      api.createRecord('35d9c93d', component.options)
    } else {
      api.reload('35d9c93d', component.options)
    }
    module.hot.accept("./PlotList.vue?vue&type=template&id=35d9c93d&scoped=true", function () {
      api.rerender('35d9c93d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/PlotList.vue"
export default component.exports